// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__266av","buttons":"PendingPaymentAlert_buttons__4Hf73"};